import React from "react";

function RichText({ text, className }) {
  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: text }}></div>
  );
}

export default RichText;
